import {css} from '@emotion/core'

export const fadeIn = (show, duration = 0.06, delay = 0.1) => css`
    transition: opacity, visibility, ${duration}s ease;
    opacity: ${show ? '1' : '0'};
    visibility: ${show ? 'visible' : 'hidden'};
    animation-delay: ${delay}s;
`
